import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {OrgService} from '../../core/services/org.service';

@Component({
  selector: 'awair-invite-guide',
  template: `
    <div class="invite-container">
      <h1>Invite Your Team Members!</h1>
      <p>
        Your members will be able to access the dashboard, add devices, and view notifications.
      </p>
      <button mat-button (click)="invite()">Invite Members</button>
      <a (click)="skip()">Skip</a>
    </div>
  `,
  styleUrls: ['./invite-guide.component.scss']
})
export class InviteGuideComponent implements OnInit {
  private orgToken: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private orgService: OrgService,
              private dialogRef: MatDialogRef<InviteGuideComponent>) {
    this.orgToken = data.token;
  }

  ngOnInit() {
  }

  skip() {
    this.orgService.finishOnboarding(this.orgToken).subscribe(() => {
      this.dialogRef.close('skip');
    });
  }

  invite() {
    this.dialogRef.close({skip: false});
  }
}
